export var BadgeTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        badge: {
            '&.MuiBadge-standard': {
                minWidth: 18,
                height: 18,
                fontSize: theme.typography.body4.fontSize,
                fontWeight: "bold",
            },
        },
    },
}); };
export default BadgeTheme;
//# sourceMappingURL=theme.js.map